import React from 'react';
import Card from '@mui/material/Card';

const Legend = () => (
  <Card style={{ maxWidth: 500, display: 'flex', borderRadius: '15px', height: '45px', alignItems: 'center', justifyContent: 'center', float: 'right' }}>
    <section style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: "center" }}>
      <div className="green" style={{ width: '20px', height: '20px', marginLeft: '15px', marginRight: '10px', borderRadius: '5px' }}></div>
      <div><span className="openSans">Above Restock</span></div>
      <div className="yellow" style={{ width: '20px', height: '20px', marginLeft: '20px', marginRight: '10px', borderRadius: '5px' }}></div>
      <div><span className="openSans">Below Restock</span></div>
      <div className="red" style={{ width: '20px', height: '20px', marginLeft: '20px', marginRight: '10px', borderRadius: '5px' }}></div>
      <div><span className="openSans" style={{ marginRight: '15px' }}>Zero stock</span></div>
    </section>
  </Card>
);

export default Legend;


